import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import SuperAdmin from "@/pages/SuperAdmin";
import OperatorLogin from "@/pages/OperatorLogin";
import OperatorPanel from "@/pages/OperatorPanel";
import Gallery from "@/pages/Gallery";
import MobileAlerts from "@/pages/MobileAlerts";
import Playback from "@/pages/Playback";
import { Toaster } from "@/components/ui/sonner";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gallery"
              element={
                <ProtectedRoute>
                  <Gallery />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alerts"
              element={
                <ProtectedRoute>
                  <MobileAlerts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/playback"
              element={
                <ProtectedRoute>
                  <Playback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super"
              element={
                <ProtectedRoute requireSuperAdmin>
                  <SuperAdmin />
                </ProtectedRoute>
              }
            />
            {/* Hidden operator console */}
            <Route path="/nvr-console" element={<OperatorLogin />} />
            <Route
              path="/nvr-console/panel"
              element={
                <ProtectedRoute requireOperator>
                  <OperatorPanel />
                </ProtectedRoute>
              }
            />
            {/* Stripe payment result pages */}
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
